import { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { debtStatus } from 'utils';
import {
  AccrualsSector,
  SectorsForAccruals,
} from 'constants/sectors-for-accruals';
import {
  AccrualsWrapper,
  BottomBlock,
  DebtMessage,
  DebtMessageWrapper,
  Divider,
  InfoIcon,
  Line,
  LoaderWrapper,
  RowParamBlock,
  StyledSpan,
  Title,
  UpperBlock,
  Wrapper,
} from './status.styled';
import { LinesLoader } from '../../loaders';
import { CurrentAddress } from '../current-address';

interface IProps {
  inCallCard: boolean;
}

export const Status = observer(({ inCallCard }: IProps) => {
  const { constants, tenants, createRequest } = useStore();

  useEffect(() => {
    const memberId = createRequest.applicant.memberId;

    if (!memberId) {
      return;
    }

    // Проверяем, нужно ли загружать новые данные
    const needToLoadSectors =
      !tenants.statuses.sectors.pending &&
      (!tenants.statuses.sectors.fulfilled ||
        tenants.tenantStats?._id !== memberId);

    const needToLoadStats =
      !tenants.statuses.stats.pending &&
      (!tenants.statuses.stats.fulfilled ||
        tenants.tenantStats?._id !== memberId);

    // Загружаем секторы для нового жителя
    if (needToLoadSectors) {
      tenants.getTenantSectors(memberId);
    }

    // Загружаем статистику для нового жителя
    if (needToLoadStats) {
      tenants.getTenantStats(memberId);
    }
  }, [createRequest.applicant.memberId]);

  const getActualSectors = (): {
    sectors: { text: string; value: number }[];
    all: false | number;
  } => {
    let totalDebt = 0;

    const sectors = constants.requests.AccrualsSectorType.filter(
      (item) =>
        SectorsForAccruals.includes(item.value as AccrualsSector) &&
        typeof tenants.getSectorsData(item.value) === 'number'
    ).map((item) => {
      totalDebt += tenants.getSectorsData(item.value)!;

      return {
        text: item.text,
        value: tenants.getSectorsData(item.value)!,
      };
    });

    return {
      sectors: sectors,
      all: !!sectors.length && totalDebt,
    };
  };

  const actualSectors = useMemo(
    () => getActualSectors(),
    [tenants.statuses.stats.pending]
  );

  return (
    <Wrapper>
      {!inCallCard &&
        !tenants.statuses.sectors.pending &&
        typeof actualSectors.all === 'number' &&
        actualSectors.all > 0 && (
          <DebtMessageWrapper>
            <InfoIcon />
            <DebtMessage>ЗАДОЛЖЕННОСТЬ</DebtMessage>
          </DebtMessageWrapper>
        )}
      <CurrentAddress />
      <RowParamBlock>
        {!inCallCard && <Title>Состояние ЛС</Title>}
        <AccrualsWrapper>
          {tenants.statuses.sectors.pending ? (
            <LoaderWrapper>
              <LinesLoader size={'medium'} loaderType={'tenant'} />
            </LoaderWrapper>
          ) : (
            <>
              {!!actualSectors.sectors.length && (
                <>
                  <UpperBlock>
                    {actualSectors.sectors.map((item, index: number) => (
                      <Line key={index}>
                        <span>{item.text}</span>
                        <StyledSpan debt={item.value > 0}>
                          {debtStatus(item.value)}
                        </StyledSpan>
                      </Line>
                    ))}
                  </UpperBlock>
                  <Divider />
                </>
              )}

              <BottomBlock>
                <span>Все начисления по объекту</span>
                {typeof actualSectors.all === 'number' ? (
                  <StyledSpan debt={actualSectors.all > 0}>
                    {debtStatus(actualSectors.all)}
                  </StyledSpan>
                ) : (
                  <StyledSpan debt={true}>
                    Данных по объекту не найдено
                  </StyledSpan>
                )}
              </BottomBlock>
            </>
          )}
        </AccrualsWrapper>
      </RowParamBlock>
    </Wrapper>
  );
});
